/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { getUserAttributes } from '../utils/auth';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_SERVICE_HOST,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  function (config: any) {
    const newConfig = { ...config };
    const userInfo = getUserAttributes();
    newConfig.headers = {
      Authorization: `Bearer ${userInfo.accessToken}`,
    };

    return newConfig;
  },
  function (error: any) {
    return Promise.reject(error);
  },
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response: any) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
  function (error: any) {
    if (error?.response?.status === 401 || error?.response?.status === 302 || error?.response?.type === 'opaqueredirect') {
      localStorage.setItem("isSignedOutOrTokenExpired", JSON.stringify(true));
      sessionStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
